import { render, staticRenderFns } from "./RouterContainer.vue?vue&type=template&id=4f70a044&scoped=true&"
import script from "./RouterContainer.vue?vue&type=script&lang=js&"
export * from "./RouterContainer.vue?vue&type=script&lang=js&"
import style0 from "./RouterContainer.vue?vue&type=style&index=0&id=4f70a044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70a044",
  null
  
)

export default component.exports